/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled'

export type Props = {
  inline?: boolean
  gap?: string
  horizontal?: true
  align?: 'center' | 'flex-start' | 'flex-end' | 'baseline'
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
}

export const Stack = styled('div')<Props>`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  justify-content: ${({ justify }) => justify};
  align-items: ${({ align }) => align};
  ${({ horizontal }) => (horizontal ? horizontalStyle : verticalStyle)}
`

const verticalStyle = ({ gap = '10px' }) => css`
  flex-direction: column;

  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  & > * + * {
    margin-top: ${gap};
  }
`

const horizontalStyle = ({ gap = '10px' }) => css`
  & > * {
    margin-left: 0;
    margin-right: 0;
  }

  & > * + * {
    margin-left: ${gap};
  }
`
